import React, { useEffect, useState } from 'react'

function ItemSucursal(props) {
    const { sucursal,guardarInfo} = props;
    const [editar, setEditar] = useState(false);
    function guardarInformacion(){
        var info = sucursal.ALARMA
        for(var dato of info){
            dato.IP_ALARMA = document.getElementById(dato.DESCRIPCION.replace(' ','')+dato.ID_SUCURSAL).value;
        }
        guardarInfo(info);
        setEditar(false);
    }
    useEffect(()=>{

    },[sucursal])
    return (
        <tr>
            <th>{sucursal.SUCURSAL}</th>
            {sucursal.ALARMA.map((item, index) => {
                if (editar === false) {
                    return (<td scope="row" key={index}>{item.IP_ALARMA}</td>)
                } else {
                    return (<td scope="row" key={index}><input className='form-control' defaultValue={item.IP_ALARMA} id={item.DESCRIPCION.replace(' ','')+item.ID_SUCURSAL}></input></td>)
                }
            })}
            {editar === false && <td><button className='btn btn-warning btn-sm' onClick={() => setEditar(true)}>Editar</button></td>}
            {editar && <td><button className='btn btn-success btn-sm' onClick={() => guardarInformacion()}>Guardar</button></td>}
            {editar && <td><button className='btn btn-danger btn-sm' onClick={() => setEditar(false)}><i className="fa-solid fa-rectangle-xmark"></i></button></td>}
        </tr>
    )
}

export default ItemSucursal